import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import legacyRunModal from 'ui-library/legacyRunModal';

import CreateConnectionModal from '../CreateConnectionModal';

export default function NewConnectionButton(): JSX.Element {
  return (
    <div className="u-display-inline-block">
      <Tooltip title="Create connection" placement={TooltipPlacement.BOTTOM} container="body">
        <Button
          aria-label="Create"
          buttonStyle={ButtonStyle.TERTIARY_BLUE}
          icon="compose"
          onClick={() => {
            legacyRunModal(CreateConnectionModal, {});
          }}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    </div>
  );
}
